// extracted by mini-css-extract-plugin
export default {"genericCard":"Ur-z","inline":"Vr-z","mastercard":"Wr-z","discover":"Xr-z","visa":"Yr-z","amex":"Zr-z","active":"_r-z"};